"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8502],{

/***/ 8502:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _lib_ads__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4498);



// @refresh reset
function OneAOneAds() {
    var tag = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)("div-gpt-ad-1x1generico-".concat(new Date().getTime() + Math.floor(Math.random() * 100)));
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var googletag = window.googletag;
        var sizeOneAOne = (0,_lib_ads__WEBPACK_IMPORTED_MODULE_2__/* .getSizesByAdType */ .V)("1x1");
        googletag.cmd.push(function() {
            var REFRESH_KEY = "refresh";
            var REFRESH_VALUE = "true";
            googletag.pubads().enableAsyncRendering();
            var slotGt = googletag.defineSlot("/22189562696/1x1", sizeOneAOne, tag.current).setTargeting(REFRESH_KEY, REFRESH_VALUE).setTargeting("refreshed_slot", "false").addService(googletag.pubads());
            googletag.display(tag.current);
            googletag.pubads().refresh([
                slotGt
            ]);
        });
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        id: tag.current,
        className: "oneaone",
        "data-ad": "true",
        style: {
            height: 1,
            width: 1,
            position: "absolute",
            top: 0,
            left: 0
        }
    });
}
var OneAOneAdGeneratorMemo = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(OneAOneAds, function() {
    return true;
});
/* harmony default export */ __webpack_exports__["default"] = (OneAOneAdGeneratorMemo);


/***/ }),

/***/ 4498:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ getSizesByAdType; },
/* harmony export */   "u": function() { return /* binding */ getDevicesByAdType; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9815);
/* eslint-disable @typescript-eslint/ban-types */ 
var billboardSizesDefault = [
    [
        970,
        90
    ],
    [
        728,
        90
    ],
    [
        970,
        250
    ], 
];
var rectangleSizesDefault = [
    [
        300,
        250
    ],
    [
        336,
        280
    ], 
];
var rectangleSizesDefaultPlus = [
    [
        160,
        600
    ],
    [
        300,
        50
    ],
    [
        300,
        75
    ],
    [
        300,
        100
    ],
    [
        300,
        600
    ],
    [
        320,
        50
    ],
    [
        320,
        100
    ],
    [
        320,
        480
    ], 
].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(rectangleSizesDefault));
var AdsDefs = {
    billboard: {
        sizes: billboardSizesDefault,
        enableMobile: false,
        enableDesktop: true,
        children: {
            main: {
                children: {
                    home: {
                        sizes: billboardSizesDefault,
                        enableMobile: false,
                        enableDesktop: true
                    },
                    listing: {
                        sizes: billboardSizesDefault,
                        enableMobile: false,
                        enableDesktop: true
                    }
                }
            },
            footer: {
                sizes: billboardSizesDefault,
                enableMobile: false,
                enableDesktop: true
            }
        }
    },
    rectangle: {
        children: {
            main: {
                children: {
                    home: {
                        sizes: rectangleSizesDefaultPlus,
                        enableMobile: true,
                        enableDesktop: false
                    },
                    listing: {
                        sizes: rectangleSizesDefaultPlus,
                        enableMobile: true,
                        enableDesktop: false
                    },
                    internal: {
                        sizes: rectangleSizesDefaultPlus,
                        enableMobile: true,
                        enableDesktop: true
                    }
                }
            },
            side: {
                sizes: rectangleSizesDefault,
                enableMobile: false,
                enableDesktop: true
            },
            footer: {
                sizes: rectangleSizesDefaultPlus,
                enableMobile: true,
                enableDesktop: false
            },
            collector: {
                sizes: rectangleSizesDefault,
                enableMobile: true,
                enableDesktop: true
            }
        }
    },
    halfpage: {
        sizes: [
            [
                300,
                600
            ],
            [
                120,
                600
            ],
            [
                160,
                600
            ]
        ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(rectangleSizesDefault)),
        enableMobile: false,
        enableDesktop: true
    },
    background: {
        children: {
            "bg-topo-desktop": {
                sizes: [
                    [
                        2000,
                        750
                    ]
                ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(billboardSizesDefault)),
                enableMobile: false,
                enableDesktop: true
            },
            "topo-mobile": {
                sizes: [
                    [
                        2000,
                        750
                    ],
                    [
                        300,
                        50
                    ],
                    [
                        300,
                        100
                    ],
                    [
                        320,
                        50
                    ],
                    [
                        320,
                        100
                    ], 
                ],
                enableMobile: true,
                enableDesktop: false
            }
        }
    },
    anchor: {
        sizes: [
            [
                320,
                50
            ],
            [
                300,
                50
            ],
            [
                1,
                1
            ]
        ],
        enableMobile: true,
        enableDesktop: false
    },
    Anchor_Footer: {
        sizes: [
            [
                728,
                90
            ],
            [
                970,
                90
            ],
            [
                1,
                1
            ]
        ],
        enableMobile: false,
        enableDesktop: true
    },
    Interstitial_2023: {
        sizes: [
            [
                336,
                280
            ],
            [
                300,
                250
            ],
            [
                320,
                480
            ], 
        ],
        enableMobile: true,
        enableDesktop: true
    },
    "1x1": {
        sizes: [
            [
                1,
                1
            ]
        ],
        enableMobile: true,
        enableDesktop: true
    }
};
function getSizesByAdType(adType) {
    var adTypeSplit = adType.replace(/-\d+$/, "").split("/");
    var sizes = [
        []
    ];
    var currentObj = AdsDefs;
    adTypeSplit.forEach(function(key, index) {
        var ref;
        if (((ref = currentObj[key]) === null || ref === void 0 ? void 0 : ref.children) && index < adTypeSplit.length - 1) {
            var ref1;
            currentObj = (ref1 = currentObj[key]) === null || ref1 === void 0 ? void 0 : ref1.children;
        } else {
            var ref2;
            sizes = (ref2 = currentObj[key]) === null || ref2 === void 0 ? void 0 : ref2.sizes;
        }
    });
    return sizes;
}
function getDevicesByAdType(adType) {
    var adTypeSplit = adType.replace(/-\d+$/, "").split("/");
    var devices;
    var currentObj = AdsDefs;
    adTypeSplit.forEach(function(key, index) {
        var ref;
        if (((ref = currentObj[key]) === null || ref === void 0 ? void 0 : ref.children) && index < adTypeSplit.length - 1) {
            var ref1;
            currentObj = (ref1 = currentObj[key]) === null || ref1 === void 0 ? void 0 : ref1.children;
        } else {
            var ref2, ref3;
            devices = {
                desktop: (ref2 = currentObj[key]) === null || ref2 === void 0 ? void 0 : ref2.enableDesktop,
                mobile: (ref3 = currentObj[key]) === null || ref3 === void 0 ? void 0 : ref3.enableMobile
            };
        }
    });
    return devices;
}


/***/ })

}]);